import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useTable, useSortBy, useGlobalFilter, usePagination } from "react-table";
import { getPGJOrgData } from "../../api/PupilApi";
import { Link } from "react-router-dom";
import InvoicePopup from "./InvoicePopup";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { jsPDF } from "jspdf";
import logos from "../../../src/assets/images/logos/palanigounder.png"

const flattenProductData = (data) => {
  return data.flatMap((category) =>
    category.productInfoList.map((product) => ({
      category: category.category,
      productName: product.productName,
      size: product.size,
      weight: product.weight,
      price: product.price,
      quantity: product.quantity,
      color: product.color,
      badge: product.badge,
      description: product.des,
      wastage: product.wastage,
      stockType: product.stockType,
      designName: product.designName,
      onboardDate: product.onboardDate,
      goldRateWhileOnboard: product.goldRateWhileOnboard,
      pgjWastage: product.pgjWastage,
      _id: product._id,
    
    }))
  );
};

const InventoryDataTab = () => {
  const [loading, setLoading] = useState(true);
  const [flattenedData, setFlattenedData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchId, setSearchId] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isInvoicePopupOpen, setIsInvoicePopupOpen] = useState(false);

  

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getPGJOrgData("orgData@gmail.com");
        if (response.data.success) {
          setFlattenedData(flattenProductData(response.data.data));
        }
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);


  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };
const clearSelectedItems = () => {
  setSelectedItems([]); // Assuming you have a state setter for selected items
};
  const handleGenerateInvoice = () => {
    if (selectedItems.length === 0) return;
    setIsInvoicePopupOpen(true);
  };
  const filteredData = useMemo(() => {
    return searchId ? flattenedData.filter((item) => item._id === searchId) : flattenedData;
  }, [searchId, flattenedData]);

  const data = useMemo(() => filteredData, [filteredData]);

 const columns = useMemo(
  () => [
    {
      Header: "Select",
      accessor: "select",
      Cell: ({ row }) => (
        <input
          type="checkbox"
          checked={selectedItems.some(
            (item) => item._id === row.original._id
          )}
          onChange={() => handleSelectItem(row)}
        />
      ),
    },
    { Header: "ID", accessor: "_id" },
    { Header: "Category", accessor: "category" },
    { Header: "Product Name", accessor: "productName" },
    { Header: "Weight", accessor: "weight" },
    { Header: "Price", accessor: "price" },
    { Header: "Stock Type", accessor: "stockType" },
    { Header: "Action", accessor: "action" },
    { Header: "Billing Address", accessor: "billingAddress" },
    { Header: "Shipping Address", accessor: "shippingAddress" },
  ],
  [selectedItems, handleSelectItem] // include both dependencies
);

const handleSelectItem = useCallback(
  (row) => {
    const isSelected = selectedItems.some(
      (item) => item._id === row.original._id
    );

    if (isSelected) {
      // Remove from selected items
      setSelectedItems((prevItems) =>
        prevItems.filter((item) => item._id !== row.original._id)
      );
    } else {
      const confirmSelection = window.confirm(
        `Are you sure you want to add ${row.original.productName}?`
      );
      if (confirmSelection) {
        setSelectedItems((prevItems) => [...prevItems, row.original]);
      }
    }
  },
  [selectedItems] // dependencies for callback
);

  
 const handleDownloadInventory = () =>{
console.log(filteredData);
generateInventoryPDF();
 };

 const generateInventoryPDF = () => {
  const doc = new jsPDF();

  // Add logo
  const img = new Image();
  img.src = logos;
  doc.addImage(img, "PNG", 10, 10, 40, 20);

  // Title
  doc.setFontSize(16);
  doc.text("Inventory Report", 70, 40);

  // Clean and filter data
  const filteredData = data.filter(item => item.category || item.productName || item.weight || item.price);

  // Convert data to table rows
  const rows = filteredData.map((item, index) => [
    index + 1,
    item.category || "-",
    item.productName || "-",
    item.size || "-",
    item.weight || "-",
    item.price || "-",
    item.stockType || "-"
  ]);

  // Define table columns
  const columns = ["S.No", "Category", "Product Name", "Size", "Weight", "Price", "Stock Type"];

  // Add table to PDF
  doc.autoTable({
    startY: 50,
    head: [columns],
    body: rows,
  });

  // Save PDF
  doc.save("inventory.pdf");
};


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setGlobalFilter,
    state: { globalFilter },
  } = useTable(
    { columns, data },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <div className="p-6">
      <div className="mb-6 space-y-4">
        <Link to="/product">
          <button className="bg-indigo-600 text-white px-6 py-2 rounded-md hover:bg-indigo-700 w-full sm:w-auto">
            Onboard Product
          </button>
        </Link>
        <button onClick={togglePopup} className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 w-full sm:w-auto">
          Review Selected Items
        </button>
        <button className="bg-green-600 text-white px-6 py-2 rounded-md hover:bg-green-700 w-full sm:w-auto">
          Download Invoice
        </button>
        <Link to="/updateExpenses">
        <button className="bg-yellow-600 text-white px-6 py-2 rounded-md hover:bg-yellow-700 w-full sm:w-auto">
          Update Expenses
        </button>
        </Link>
        <button className="bg-red-600 text-white px-6 py-2 rounded-md hover:bg-red-700 w-full sm:w-auto">
          Generate Report
        </button>
      </div>

      <h2 className="text-xl font-bold mb-4">Inventory Analysis Dashboard</h2>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <div className="mb-6 flex gap-4">
            <input
              type="text"
              placeholder="Search by ID..."
              value={searchId}
              onChange={(e) => setSearchId(e.target.value)}
              className="border p-2 w-1/3"
            />
            <input
              type="text"
              placeholder="Global Search..."
              value={globalFilter || ""}
              onChange={(e) => setGlobalFilter(e.target.value)}
              className="border p-2 w-1/3"
            />
          </div>

         
<table {...getTableProps()} className="min-w-full border">
  <thead>
    {headerGroups.map((headerGroup) => (
      <tr {...headerGroup.getHeaderGroupProps()}>
        {headerGroup.headers.map((column) => (
          <th
            {...column.getHeaderProps(column.getSortByToggleProps())}
            className="px-4 py-2 border"
          >
            {column.render("Header")}{" "}
            {column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}
          </th>
        ))}
      </tr>
    ))}
  </thead>
  <tbody {...getTableBodyProps()}>
    {rows.map((row) => {
      prepareRow(row);
      return (
        <tr {...row.getRowProps()}>
          {row.cells.map((cell) => (
            <td {...cell.getCellProps()} className="border px-4 py-2">
              {cell.column.id === "action" ? (
                <div className="flex gap-2 justify-center">
                 
  <button
    className="flex items-center gap-1 bg-blue-600 hover:bg-blue-700 text-white text-sm px-3 py-1.5 rounded-lg shadow transition duration-300"
    onClick={handleDownloadInventory}
  >
    <FaCloudDownloadAlt className="text-base" />
    
  </button>
  <button
    className="flex items-center gap-1 bg-red-500 hover:bg-red-600 text-white text-sm px-3 py-1.5 rounded-lg shadow transition duration-300"
  >
    <MdCancel className="text-base" />
   
  </button>


                </div>
              ) : (
                cell.render("Cell")
              )}
            </td>
          ))}
        </tr>
      );
    })}
  </tbody>
</table>

          {/* Popup for Reviewing Selected Items */}
          {isPopupOpen && (
  <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex items-center justify-center">
    <div className="bg-white p-6 rounded-md w-1/2">
      <h3 className="text-xl font-bold mb-4">Selected Items</h3>
      <ul className="mb-4">
        {selectedItems.map((item) => (
          <li key={item._id}>
            {item.productName} - Rs. {item.price} per unit
          </li>
        ))}
      </ul>
      <div className="flex flex-col sm:flex-row gap-2">
        <button
          onClick={handleGenerateInvoice}
          className="bg-green-600 text-white px-6 py-2 rounded-md hover:bg-green-700 w-full sm:w-auto"
        >
          Generate Invoice
        </button>
        <button
          onClick={clearSelectedItems}
          className="bg-red-600 text-white px-6 py-2 rounded-md hover:bg-red-700 w-full sm:w-auto"
        >
          Clear
        </button>
        <button
          onClick={togglePopup}
          className="bg-gray-600 text-white px-6 py-2 rounded-md hover:bg-gray-700 w-full sm:w-auto"
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

      {/* Invoice Popup */}
     {isInvoicePopupOpen && (
  <InvoicePopup selectedItems={selectedItems} onClose={() => setIsInvoicePopupOpen(false)} />
)}
        </>
      )}
    </div>
  );
};

export default InventoryDataTab;
